// extracted by mini-css-extract-plugin
export default {"header":"SectionCard_header__+iA4+"};